import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function HepatitisDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Hepatitis/HIV Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please confirm diagnosis and date of diagnosis:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosis.referToAttachments}>
                        <p>{questions.diagnosis.value}</p>

                        <Question>Date of diagnosis:</Question>
                        <p>{questions.diagnosis.subQuestions.dateOfDiagnosis}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please confirm treatment and date treatment commenced:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatment.referToAttachments}>
                        <p>{questions.treatment.value}</p>

                        <Question>Date treatment commenced:</Question>
                        <p>{questions.treatment.subQuestions.dateCommenced}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please provide details of the last 3 serology results, viral loads & CD4 count (where applicable):</Question>
                    <ReferrableQuestionWrapper isReferred={questions.detailsOfSerologyResults.referToAttachments}>
                        <OutputDetails
                            details={questions.detailsOfSerologyResults.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Has your patient had any other investigations?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.investigations.referToAttachments}>
                        <p>{questions.investigations.value}</p>
                        {questions.investigations.value === 'Yes' && (
                            <>
                                <Question>If yes, please confirm results:</Question>
                                <OutputDetails
                                    details={questions.investigations.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Please confirm if your patient has been compliant with treatment and recommended follow up?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.compliantWithTreatment.referToAttachments}>
                        <p>{questions.compliantWithTreatment.value}</p>

                        <Question
                            show={questions.compliantWithTreatment.value === 'No'}
                            answer={questions.compliantWithTreatment.details}
                        >
                            If no, please provide details:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Is there a history of IV drug use?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.historyOfDrugUse.referToAttachments}>
                        <p>{questions.historyOfDrugUse.value}</p>

                        {questions.historyOfDrugUse.value === 'Yes' && (
                            <>
                                <Question>If yes, please confirm details of drugs taken and date last used:</Question>
                                <p>{questions.historyOfDrugUse.subQuestions.details}</p>

                                <Question>Date last used:</Question>
                                <p>{formatDateMonthYear(questions.historyOfDrugUse.subQuestions.dateLastUsed)}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}